import { camelizeKeys } from 'humps';

export const patchIn = (state, id, data) => state.mergeIn([id], camelizeKeys(data));
